import { useEffect, useState } from "react";

/**
 * School switcher for multi-school admins.
 *
 * Reads the managed schools + the currently-active school from localStorage
 * (populated at login). Changing the selection updates `activeSchoolId` and
 * reloads so every school-scoped request re-fires with the new x-school-id
 * header (attached by the axios interceptor in httpServices).
 *
 * Renders nothing for any role other than multi_school_admin.
 */
const SchoolSwitcher = () => {
  const [schools, setSchools] = useState([]);
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    if (localStorage.getItem("userrole") !== "multi_school_admin") return;
    try {
      const list = JSON.parse(localStorage.getItem("managedSchools") || "[]");
      setSchools(Array.isArray(list) ? list : []);
      setActiveId(localStorage.getItem("activeSchoolId") || "");
    } catch (e) {
      setSchools([]);
    }
  }, []);

  if (localStorage.getItem("userrole") !== "multi_school_admin") return null;
  if (!schools.length) return null;

  const handleChange = (e) => {
    const id = e.target.value;
    setActiveId(id);
    localStorage.setItem("activeSchoolId", id);
    // Reload so dashboard/teacher data refetches under the newly selected school.
    window.location.reload();
  };

  return (
    <div className="school-switcher" style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <label htmlFor="school-switcher-select" style={{ fontSize: 12, fontWeight: 600, opacity: 0.8 }}>
        School
      </label>
      <select
        id="school-switcher-select"
        value={activeId}
        onChange={handleChange}
        aria-label="Select school to manage"
        style={{
          padding: "6px 10px",
          borderRadius: 6,
          border: "1px solid #d0d0d0",
          maxWidth: 240,
          fontSize: 14,
        }}
      >
        {schools.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SchoolSwitcher;
